import { GetResolvedDatesRequest, ResolvedDate } from "@models";
import { availabilityService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class AvailabilityStore {
  resolvedDates: ResolvedDate[] = [];
  loading = false;
  resolvedDatesScopeKey: string | undefined = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  getResolvedDates = async (request: GetResolvedDatesRequest) => {
    const key = `${request.userIds.join(",")}|${request.tenantId}|${request.from}|${request.to}|${request.requiredMinutes ?? 0}`;
    if (this.resolvedDatesScopeKey === key) return;
    this.setLoading(true);
    runInAction(() => {
      this.resolvedDatesScopeKey = key;
    });
    try {
      const response = await availabilityService.getResolvedDates(request);
      runInAction(() => {
        if (this.resolvedDatesScopeKey !== key) return;
        this.resolvedDates = response;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        if (this.resolvedDatesScopeKey !== key) return;
        this.resolvedDatesScopeKey = undefined;
        this.loading = false;
      });
    }
  };

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  clearResolvedDates = () => {
    runInAction(() => {
      this.resolvedDates = [];
      this.resolvedDatesScopeKey = undefined;
    });
  };
}
